var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM1.58133 8C1.58133 11.5449 4.45507 14.4187 8 14.4187C11.5449 14.4187 14.4187 11.5449 14.4187 8C14.4187 4.45507 11.5449 1.58133 8 1.58133C4.45507 1.58133 1.58133 4.45507 1.58133 8Z",
    fill: "#6C7A93",
    fillOpacity: 0.39
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotStarted);
export default __webpack_public_path__ + "static/media/not_started.d1c8c056820d441e57d1b241d5e56f1c.svg";
export { ForwardRef as ReactComponent };